import { APP_PERMISSIONS } from '@exam-center/permission';
import { PermissionRoute, type PermissionRouteData } from '@exam-center/router';
import { useMemo } from 'react';

interface ExamEventPermissionRouteProps {
  examCenterCode: string;
  currentYear: string;
}

export default function ExamEventPermissionRoute(props: Readonly<ExamEventPermissionRouteProps>) {
  const { examCenterCode, currentYear } = props;

  const routes = useMemo<PermissionRouteData[]>(
    () => [
      {
        path: '/:examCenterCode/exam-events/years/:year',
        params: { examCenterCode, year: currentYear },
        requiredPermission: [
          APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAM_EVENT.VIEW,
          APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAMINEES.VIEW,
          APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.RESULTS.VIEW,
        ],
      },
      {
        path: '/:examCenterCode/exam-events/activity-log',
        params: { examCenterCode },
        requiredPermission: [APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.AUDIT_LOG.VIEW],
      },
    ],
    [examCenterCode, currentYear],
  );

  return <PermissionRoute routes={routes} />;
}
